import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Badge } from "../../../Component/AdminComponents/Badge";
import EmployeeDashboard from "../../Employee/Dashboard";

function InfoRow({ label, value }) {
  return (
    <div className="flex justify-between">
      <span className="text-slate-500">{label}</span>
      <span className="font-medium text-slate-800">
        {value || "—"}
      </span>
    </div>
  );
}

export default function EmployeeDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const employee = location.state?.employee;
  const [activeTab, setActiveTab] = useState("leads");


  const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");
  const isManager = employee?.position === "MANAGER";

  if (!employee) {
    return (
      <div className="p-10 text-center">
        <p className="text-red-500">No employee data found.</p>
        <button
          onClick={() => navigate(-1)}
          className="mt-4 text-blue-600 underline"
        >
          Go Back
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-100 p-6">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

        {/* LEFT PROFILE CARD */}
       <div className="bg-white rounded-2xl shadow p-6">

  {/* ===== PROFILE HEADER ===== */}
  <div className="flex flex-col items-center text-center">
    <div className="relative">
      <img
        src={employee.photo_url}
        alt="profile"
        className="w-28 h-28 rounded-full object-cover border-4 border-white shadow"
      />
    </div>

    <h2 className="mt-4 text-xl font-semibold text-slate-900">
      {employee.first_name} {employee.last_name}
    </h2>

    <p className="text-sm text-slate-500">
      {employee.position}
    </p>

    <p className="text-xs text-slate-400 font-medium">
      ID: {employee.employee_id}
    </p>
  </div>

  {/* ===== CONTACT INFO ===== */}
  <div className="mt-6 border-t pt-5">
    <h3 className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-3">
      Contact Information
    </h3>

    <div className="space-y-2 text-sm">
      <InfoRow label="Official Email" value={employee.official_email} />
      <InfoRow label="Official Phone" value={employee.official_phone} />
      <InfoRow label="Personal Phone" value={employee.personal_phone} />
    </div>
  </div>

  {/* ===== LOCATION INFO ===== */}
  <div className="mt-6 border-t pt-5">
    <h3 className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-3">
      Location
    </h3>

    <div className="space-y-2 text-sm">
      <InfoRow label="State" value={employee.state} />
      <InfoRow label="District" value={employee.district} />
      <InfoRow label="Location Mode" value={employee.location_mode} />
    </div>
  </div>

  {/* ===== PROFESSIONAL INFO ===== */}
  <div className="mt-6 border-t pt-5">
    <h3 className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-3">
      Professional Details
    </h3>

    <div className="space-y-2 text-sm">
      <InfoRow label="Employee Type" value={employee.employee_type} />
      <InfoRow label="User Type" value={employee.type_of_user} />
    </div>
  </div>

  {/* ===== CATEGORIES ===== */}
  <div className="mt-6 border-t pt-5">
    <h3 className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-3">
      Categories
    </h3>

    <div className="flex flex-wrap gap-2">
      {employee.categories?.length ? (
        employee.categories.map((cat, i) => (
          <Badge key={i} color="blue">
            {cat}
          </Badge>
        ))
      ) : (
        <span className="text-xs text-slate-400">No categories assigned</span>
      )}
    </div>
  </div>

  {/* ===== HANDLES ===== */}
  <div className="mt-6 border-t pt-5">
    <h3 className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-3">
      Handles
    </h3>

    <div className="flex flex-wrap gap-2">
      {employee.handle?.length ? (
        employee.handle.map((h, i) => (
          <Badge key={i} color="green">
            {h}
          </Badge>
        ))
      ) : (
        <span className="text-xs text-slate-400">No handles assigned</span>
      )}
    </div>
  </div>

</div>

        {/* RIGHT CONTENT */}
        <div className="lg:col-span-2 space-y-6">

          {/* Tabs */}
         <div className="bg-white rounded-2xl shadow p-4 flex gap-6 text-sm font-medium">
            <button
              onClick={() => setActiveTab("leads")}
              className={`pb-2 ${
                activeTab === "leads"
                  ? "border-b-2 border-blue-600 text-blue-600"
                  : "text-slate-500 hover:text-blue-600"
              }`}
            >
              Leads
            </button>

            {isManager && (
              <button
                onClick={() => setActiveTab("team")}
                className={`pb-2 ${
                  activeTab === "team"
                    ? "border-b-2 border-blue-600 text-blue-600"
                    : "text-slate-500 hover:text-blue-600"
                }`}
              >
                Team Members
              </button>
            )}

            <button
              onClick={() => setActiveTab("users")}
              className={`pb-2 ${
                activeTab === "users"
                  ? "border-b-2 border-blue-600 text-blue-600"
                  : "text-slate-500 hover:text-blue-600"
              }`}
            >
              Users
            </button>
          </div>

          {/* TAB CONTENT */}
          <div className="bg-white rounded-2xl shadow p-6 text-sm">

            {activeTab === "leads" && (
              <EmployeeDashboard employeeId={employee.id} />
            )}

            {activeTab === "job" && (
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <p><strong>Position:</strong> {employee.position}</p>
                  <p><strong>User Type:</strong> {employee.type_of_user}</p>
                  <p><strong>Reports To:</strong> {employee.reports_to || "—"}</p>
                </div>
                <div>
                  <p><strong>Created At:</strong> {new Date(employee.created_at).toLocaleDateString()}</p>
                  <p><strong>Updated At:</strong> {new Date(employee.updated_at).toLocaleDateString()}</p>
                </div>
              </div>
            )}

            {activeTab === "company" && (
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <p><strong>Business Name:</strong> {employee.company?.business_name}</p>
                  <p><strong>Contact Person:</strong> {employee.company?.contact_person}</p>
                  <p><strong>Company Code:</strong> {employee.company?.company_code}</p>
                </div>
                <div>
                  <p><strong>Email:</strong> {employee.company?.contact_email}</p>
                  <p><strong>Phone:</strong> {employee.company?.contact_phone}</p>
                  <p><strong>City:</strong> {employee.company?.city}</p>
                </div>
              </div>
            )}

          </div>

        </div>
      </div>
    </div>
  );
}





// import { useLocation, useNavigate } from "react-router-dom";

// export default function EmployeeDetails() {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const employee = location.state?.employee; // ✅ get passed data

//   if (!employee) {
//     return (
//       <div className="p-6 text-center">
//         <p className="text-red-500">No employee data found.</p>
//         <button
//           onClick={() => navigate(-1)}
//           className="mt-3 text-blue-600 underline"
//         >
//           Go Back
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div className="space-y-4 p-6">
//       <h2 className="text-xl font-semibold">Employee Details</h2>

//       <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

//         <div>
//           <p><strong>Employee ID:</strong> {employee.employee_id}</p>
//           <p><strong>Name:</strong> {employee.first_name} {employee.last_name}</p>
//           <p><strong>Position:</strong> {employee.position}</p>
//           <p><strong>Type:</strong> {employee.type_of_user}</p>
//         </div>

//         <div>
//           <p><strong>Phone:</strong> {employee.official_phone || "—"}</p>
//           <p><strong>Email:</strong> {employee.official_email || "—"}</p>
//           <p>
//             <strong>Status:</strong>{" "}
//             {employee.status === 1 ? "Active" : "Inactive"}
//           </p>
//         </div>

//       </div>

//       <div>
//         <h3 className="font-semibold mt-4">Categories</h3>
//         <div className="flex flex-wrap gap-2">
//           {employee.categories?.map((cat, i) => (
//             <span
//               key={i}
//               className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-xs"
//             >
//               {cat}
//             </span>
//           ))}
//         </div>
//       </div>

//       <div>
//         <h3 className="font-semibold mt-4">Handle</h3>
//         <div className="flex flex-wrap gap-2">
//           {employee.handle?.map((h, i) => (
//             <span
//               key={i}
//               className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-xs"
//             >
//               {h}
//             </span>
//           ))}
//         </div>
//       </div>

//     </div>
//   );
// }
